import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useAppSelector } from '@verzekeringapp-mono/shared/src/hooks/state'
import { getAgency as getAgencySelector } from '@verzekeringapp-mono/shared/src/state/selectors/agency'
import {
  getClaim,
  getLatestClaimId
} from '@verzekeringapp-mono/shared/src/state/selectors/claims'
import { useNavigate } from 'react-router-dom'
import Button from '~/components/Button'

const ClaimDamageConfirmation = () => {
  const agency = useAppSelector(getAgencySelector)
  const navigate = useNavigate()

  const latestClaimId = useAppSelector(getLatestClaimId)
  const claim = useAppSelector(getClaim(latestClaimId ?? ''))

  return (
    <div className='flex justify-center items-center'>
      <div className='w-5/6 rounded-lg bg-surface-page p-8 text-center lg:w-5/6'>
        <div className='flex justify-center mb-6'>
          <div className='flex h-12 w-12 items-center justify-center rounded-full bg-status-success-strong text-2xl text-status-success-on-strong'>
            <FontAwesomeIcon icon='check' />
          </div>
        </div>

        <h2 className='mb-2 text-xl font-normal text-text-primary'>
          Schademelding ingediend bij
        </h2>

        <h3 className='mb-8 text-4xl font-medium text-text-primary'>{agency?.name}</h3>

        <p className='mb-8 text-text-primary'>{claim?.statusDescription}</p>

        <div className='flex justify-center space-x-4'>
          <Button
            onClick={() => {
              navigate(`/dossier/mijn-schades/${latestClaimId}`)
            }}
          >
            Bekijk schademelding
          </Button>

          <Button
            onClick={() => {
              navigate('/dossier/mijn-schades')
            }}
            variant='secondary'
          >
            Terug naar het overzicht
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ClaimDamageConfirmation
